function ServiceCheckboxAttr(props) {

    const { settings, serviceInfo, register } = props
    return (
        <div className="row">
            {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr1_Title') &&
                <div className="form-group col-md-2">
                    <input name="CheckBoxExtAttr1" className="form-check-input" ref={register({})} type="checkbox" defaultChecked={serviceInfo?.CheckBoxExtAttr1 ??false} />
                    &nbsp;<label className="mt-1"> {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr1_Title')?.SettingValue} </label>
                </div>
            }
            {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr2_Title') &&
                <div className="form-group col-md-2">
                    <input name="CheckBoxExtAttr2" className="form-check-input" ref={register({})} type="checkbox" defaultChecked={serviceInfo?.CheckBoxExtAttr2 ??false} />
                    &nbsp;<label className="mt-1"> {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr2_Title')?.SettingValue} </label>
                </div>
            }
            {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr3_Title') &&
                <div className="form-group col-md-2">
                    <input name="CheckBoxExtAttr3" className="form-check-input" ref={register({})} type="checkbox" defaultChecked={serviceInfo?.CheckBoxExtAttr3 ?? false} />
                    &nbsp;<label className="mt-1">{settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr3_Title')?.SettingValue} </label>
                </div>
            }
            {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr4_Title') &&
                <div className="form-group col-md-2">
                    <input name="CheckBoxExtAttr4" className="form-check-input" ref={register({})} type="checkbox" defaultChecked={serviceInfo?.CheckBoxExtAttr4 ?? false} />
                    &nbsp;<label className="mt-1"> {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr4_Title')?.SettingValue} </label>
                </div>
            }
            {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr5_Title') &&
                <div className="form-group col-md-2">
                    <input name="CheckBoxExtAttr5" className="form-check-input" ref={register({})} type="checkbox" defaultChecked={serviceInfo?.CheckBoxExtAttr5 ?? false} />
                    &nbsp;<label className="mt-1"> {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr5_Title')?.SettingValue} </label>
                </div>
            }
            {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr6_Title') &&
                <div className="form-group col-md-2">
                    <input name="CheckBoxExtAttr6" className="form-check-input" ref={register({})} type="checkbox" defaultChecked={serviceInfo?.CheckBoxExtAttr6 ?? false} />
                    &nbsp;<label> {settings.find(s => s.SettingName === 'Services_CheckBoxExtAttr6_Title')?.SettingValue} </label>
                </div>
            }
        </div>
    )
}
export default ServiceCheckboxAttr;